<div (click)="$event.stopPropagation()">
  <button class="close-button" (click)="onCloseClick()">
    <span aria-hidden="true">&times;</span>
  </button>
  <h1 mat-dialog-title>Multi-Factor Authentication</h1>
  <div mat-dialog-content>
    <div class="row margin-bottom-20">
      <div class="col-sm">
        <mat-radio-group [(ngModel)]="sendCodeOption">
          <mat-radio-button value="Mobile" class="radio-text" [disabled]="!isMobileExist">Send By SMS</mat-radio-button>
          <mat-radio-button class="margin-left-20 radio-text" value="Email" [disabled]="!isEmailExist">Send By Email</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <div class="row" *ngIf="sendCodeOption=='Mobile'">
      <div class="col-md-12 form-label">
        MOBILE NUMBER
      </div>
      <div class="col-md-12">
        <mat-form-field>
          <input matInput type="text" class="poReference" [(ngModel)]="mobileNumber" disabled/>
        </mat-form-field>
      </div>
    </div>
    <div class="row" *ngIf="sendCodeOption=='Email'">
      <div class="col-md-12 form-label">
        EMAIL ADDRESS
      </div>
      <div class="col-md-12">
        <mat-form-field>
          <input matInput type="email" class="poReference" [(ngModel)]="emailAddress" disabled/>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-button class="button button-red button-large continue" (click)="enableMFACode()">Confirm</button>
  </div>
</div>